import React from 'react';

const WaveIcon: React.FC<{ className?: string; size?: number }> = ({ className, size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={Math.round(size * 0.72)}
    viewBox="0 0 24.192 17.385"
    className={className}
  >
    <path d="M23.192 15.049a4.823 4.823 0 01-6.564 0 6.277 6.277 0 00-8.543 0 4.967 4.967 0 01-6.673.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M23.192 8.865a4.823 4.823 0 01-6.564 0 6.277 6.277 0 00-8.543 0 4.967 4.967 0 01-6.673.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M23.192 2.682a4.823 4.823 0 01-6.564 0 6.277 6.277 0 00-8.543 0 4.967 4.967 0 01-6.673.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default WaveIcon;